// extracted by mini-css-extract-plugin
module.exports = {"flipContainer":"_2ae90d5","flipper":"_ff54f9f","flipped":"_f1478c4","front":"_30b53fe","back":"_1263320"};